import { EventEmitter } from 'eventemitter3'
import type { IRange } from '@fast-editor/core'

export abstract class ToolbarElement extends EventEmitter {
  constructor(protected readonly overlayContainer: HTMLDivElement) {
    super()
  }
  public setFormat(format: { [key: string]: Set<any> }): void {}
  public setSearchResult(index: number, count: number): void {}
  public setHistoryStatus(status: { canUndo: boolean; canRedo: boolean; stackLength: number; current: number }): void {}
  public setSelection(selection: IRange[]): void {}
  public abstract getEntryElement(): HTMLElement
}
